/*
Luke Harby
slackwise LTD
https://slackwise.org.uk
2012 - present
*/

/* setColours function */
const arr = ['red', 'green', 'blue', 'orange', 'pink', 'grey', 'lime', 'black'];

const setColours = () => {
    const tags = document.querySelectorAll('.tags li a');
    if (tags.length) {
        [...tags].forEach(item => {
            const rnd = [arr.length * Math.random() | 0];
            item.classList.add(arr[rnd]);
        });
    } 
}

export { setColours }